const visualBox = ()=>import("./views/visualBox.vue");
const visualColumnList = ()=>import("./views/visualColumnList.vue");
const visualColumnDetail = ()=>import("./views/visualColumnDetail.vue");
const visualContentList = ()=>import("./views/visualContentList.vue");
const visualContentDetail = ()=>import("./views/visualContentDetail.vue");
const visualAddContent = ()=>import("./views/visualAddContent.vue");
const visualAddColumn = ()=>import("./views/visualAddColumn.vue");
const visualImageList = ()=>import("./views/visualImageList.vue");
const visualAddBanner = ()=>import("./views/visualAddBanner.vue");
const visualBannerList = ()=>import("./views/visualBannerList.vue");
const visualBannerDetail = ()=>import("./views/visualBannerDetail.vue");
const visualMapDetail = ()=>import("./views/visualMapDetail.vue");
const visualMapList = ()=>import("./views/visualMapList.vue");
const visualAddMap = ()=>import("./views/visualAddMap.vue");
const visualMapCategoryList = ()=>import("./views/visualMapCategoryList.vue");
const visualWebsiteInfo = ()=>import("./views/visualWebsiteInfo.vue");
const visualAddMessage = () => import("./views/visualAddMessage.vue");
const visualMessageFormList = () => import("./views/visualMessageFormList.vue");
const visualMessageDetail = () => import("./views/visualMessageDetail.vue");
const visualMessageList = () => import("./views/visualMessageList.vue");

export default {

  path: "/visual",
  name: "visual",
  component: visualBox,
  children: [
    {
      path: "contentList",
      name: "visualContentList",
      component: visualContentList
    },
    {
      path: "addContent",
      name: "visualAddContent",
      component: visualAddContent
    },
    {
      path: "contentDetail",
      name: "visualContentDetail",
      component: visualContentDetail
    },
    {
      path: "columnList",
      name: "visualColumnList",
      component: visualColumnList
    },
    {
      path: "addColumn",
      name: "visualAddColumn",
      component: visualAddColumn
    },
    {
      path: "columnDetail",
      name: "visualColumnDetail",
      component: visualColumnDetail
    },
    {
      path: "imageList",
      name: "visualImageList",
      component: visualImageList
    },
    {
      path: "bannerList",
      name: "visualBannerList",
      component: visualBannerList
    },
    {
      path: "addBanner",
      name: "visualAddBanner",
      component: visualAddBanner
    },
    {
      path: "bannerDetail",
      name: "visualBannerDetail",
      component: visualBannerDetail
    },
    {
      path: "mapList",
      name: "visualMapList",
      component: visualMapList
    },
    {
      path: "addMap",
      name: "visualAddMap",
      component: visualAddMap
    },
    {
      path: "mapDetail",
      name: "visualMapDetail",
      component: visualMapDetail
    },
    {
      path: "mapCategoryList",
      name: "visualMapCategoryList",
      component: visualMapCategoryList
    },
    {
      path: "websiteInfo",
      name: "visualWebsiteInfo",
      component: visualWebsiteInfo
    },
    {
      path: "messageFormList",
      name: "visualMessageFormList",
      component: visualMessageFormList
    },
    {
      path: "addMessage",
      name: "visualAddMessage",
      component: visualAddMessage
    },
    {
      path: "messageDetail",
      name: "visualMessageDetail",
      component: visualMessageDetail
    },
    {
      path: "messageList",
      name: "visualMessageList",
      component: visualMessageList
    }
  ]
}



// WEBPACK FOOTER //
// ./src/core/modules/visual/router.js